<template>
    <div class="login"  style="--colorRed:green;">
        <div class="loginContent">
            <div class="loginLogo">
                <div class="loginSlogan">
                    <div class="title">{{common.name}}</div>
                </div>  
                
            </div>
            <div class="loginBox">
                <a-form ref="formRef" :model="state.form"  :wrapper-col="{span:24}" >
                    <a-form-item label="" :rules="[{required: true, message:'请输入登录账号'}]" name="username">
                        <a-input :maxlength="50" v-model:value="state.form.username" placeholder="请输入登录账号" allow-clear/>
                    </a-form-item>
                    <a-form-item label="" :rules="[{required: true, message:'请输入密码'}]" name="password">
                        <a-input-password :maxlength="50" v-model:value="state.form.password" placeholder="请输入密码" allow-clear/>
                    </a-form-item>
                </a-form>
                <div class="loginSubmit">
                    <a-button size="large" class="systemModalStyle-submit" key="submit" type="primary" @click="loginSubmit" :loading="state.loading">登录</a-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { useStore } from 'vuex'
import {useRouter} from 'vue-router'
import { reactive, ref } from 'vue'
import common,{getEncryptCode} from '@/utils/common.js'
import {message} from 'ant-design-vue'
const store = useStore()
const router = useRouter()

const state = reactive({
    form:{
        username: null,
        password: null,
    },
    loading:false,
})
const formRef = ref()
const loginSubmit = async()=>{
    formRef.value.validateFields().then(res=>{
        let params = {
            username: state.form.username,
            password: getEncryptCode(state.form.password)
        }
        state.loading = true
        store.dispatch('userLogin',params).then(async res=>{
            if(res.code == 200){          
                let timer = setTimeout(()=>{
                    state.loading = false
                    clearTimeout(timer)
                    router.push('/')
                },1000)
            }else{
                if(res.message){
                    message.error(res.message)
                    state.loading = false
                }
                
            }
        }).catch(err=>{
            state.loading = false
        })
    }).catch(err=>{
         console.log(err)
    })
    
}



</script>
<style lang="less" scoped>
@import url('@/assets/css/theme.less');
.login{
    font-size: 16px;
    background: @login-bg-color;
    width: 100%;
    height: 100%;
    position: relative;
    .loginContent{
        width: 600px;
        margin: auto;
        background: @color-white;
        padding: 50px 0 80px 0;
        border-radius: 6px;
        position: absolute;
        left: 50%;
        top:50%;
        transform: translate(-50%,-50%);
        .loginLogo{
            padding: 10px 50px;
            margin-bottom: 20px;
            .logoBox{
                text-align: center;
                :deep(.ant-image){
                    width: 280px!important;
                    height: 90px!important;
                }
                :deep(.value){
                    font-size: 25px;
                    line-height: 40px;
                }
                :deep(.mc){
                    font-size: 20px;
                    line-height: 30px;
                }
                :deep(.title){
                    margin-left: 15px;
                }
            }   
            
        }
        .loginBox{
            padding: 0 100px;
        }
        .ant-input-affix-wrapper{
            padding: 0 11px;
            line-height: 40px;
        }
    }
    .loginSubmit{
        margin-top: 50px;
        text-align: center;
        .ant-btn{
            width: 100%;
            border-radius: 6px;
            background: @color-active;
            border: 0;
        }
    }
    .loginSlogan{
        text-align: center;
        font-size: 30px;
        font-weight: bold;
    }
}
</style>